module.exports = __webpack_public_path__ + "static/media/view.c97f788c.svg";